import { userInfoSchema } from "@/schema/free-assessment/UserInfo";
import { z } from "zod";

export const contactInfoSchema = userInfoSchema
  .omit({
    firstName: true,
    lastName: true,
    companyName: true,
  })
  .extend({
    assessment_paper_id: z.number(),
    company_name: z.string().nullish(),
    client_name: z.string().trim().min(1),
    has_inquiry_request: z.boolean(),
    referer_id: z.string().optional(),
    phone: z.string().trim().min(1),
    message: z.string().optional(),
    score: z.number(),
    free_category_results: z.array(
      z.object({
        main_category_id: z.number(),
        score: z.number(),
        free_sub_category_results: z.array(
          z.object({
            sub_category_id: z.number(),
            score: z.number(),
          })
        ),
      })
    ),
    cf_turnstile_response: z.string().trim().min(1),
  });

export type ContactInfo = z.infer<typeof contactInfoSchema>;
